import {
  // Data Visualization (charts)
  bootstrapBarChartLine,
  bootstrapBarChart,
  bootstrapBarChartLineFill,
  bootstrapBarChartSteps,

  // Robot / Automation
  bootstrapRobot,

  // Expand/Collapse
  bootstrapArrowsExpand,
  bootstrapArrowsCollapse,
  bootstrapCircleHalf,
  bootstrapArrowRepeat,
} from "@ng-icons/bootstrap-icons";

// GROUPED EXPORTS -----------------------------------------------------------
// Data Visualization (charts)
export const BOOTSTRAP_VISUALIZATION_ICONS = {
  bootstrapBarChartLine,
  bootstrapBarChart,
  bootstrapBarChartLineFill,
  bootstrapBarChartSteps,
};

// Robot / Automation
export const BOOTSTRAP_ROBOT_ICONS = {
  bootstrapRobot,
};

export const BOOTSTRAP_EXPAND_COLLAPSE_ICONS = {
  bootstrapArrowsExpand,
  bootstrapArrowsCollapse,
};

export const BOOTSTRAP_MISC_ICONS = {
  bootstrapCircleHalf,
  bootstrapArrowRepeat,
};

// Consolidated export expected by the module registration
export const BOOTSTRAP_CHART_ICONS = {
  ...BOOTSTRAP_VISUALIZATION_ICONS,
  ...BOOTSTRAP_ROBOT_ICONS,
  ...BOOTSTRAP_EXPAND_COLLAPSE_ICONS,
  ...BOOTSTRAP_MISC_ICONS,
};
